import { io } from "socket.io-client";
import { socketConnectURL } from "../../../routes/apiurls";

let socket = null;

export const createSocketConnection = (token) => {
  if (socket) return socket;
  socket = io(socketConnectURL, {
    transports: ["websocket"],
    auth: {
      token,
    },
    autoConnect: true,
  });

  socket.on("connect", () => {
    console.log("✅ Socket connected after refresh:", socket.id);
  });

  socket.on("disconnect", (reason) => {
    console.log("❌ Socket disconnected:", reason);
  });

  socket.on("connect_error", (err) => {
    console.error("⚠️ Socket connection error:", err.message);
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => socket;
